import { render } from "./auditor.vue?vue&type=template&id=5781bfe7&scoped=true"
import script from "./auditor.vue?vue&type=script&lang=js"
export * from "./auditor.vue?vue&type=script&lang=js"

import "./auditor.vue?vue&type=style&index=0&id=5781bfe7&scoped=true&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5781bfe7"]])

export default __exports__